export default __webpack_public_path__ + "static/12-a2dc69ca084ef035cc5da2b853254728.png";